import { Button, Flex, Image, Input, Text } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import Modal from "react-modal";
import Address from "../../components/Address";
import { AdminMenuBar } from "../../components/admin/AdminMenuBar";
import youtubeLink from "../../images/utub.png";
import { checkSession } from "../../services/Admin";
import { getYoutubePageCount, postYoutubeVideo } from "../../services/VideoAPI";
import "../Main.css";
import { AdminVideoList } from "./AdminVideoList";

export const AdminVideos = () => {
  Modal.setAppElement("#root");

  const [selectedPage, setSelectedPage] = useState();

  const [isModalOpen, setIsModalOpen] = useState(false);

  const [value, setValue] = useState(""); // 제목
  const handleChange = (event) => setValue(event.target.value);

  const [videoUrl, setVideoUrl] = useState(""); // url
  const handleVideoChange = (event) => setVideoUrl(event.target.value);

  const [imageInformation, setImageInformation] = useState();

  const [youtubeCount, setYoutubeCount] = useState([]);

  const changePage = (selected) => {
    window.location.href = `/admin/video?page=${selected.selected + 1}`;
  };

  useEffect(() => {
    checkSession();
    if (
      window.location.href.split("?page=").length !== 2 ||
      isNaN(window.location.href.split("?page=")[1])
    ) {
      window.location.href = `/admin/video?page=1`;
    }
    setSelectedPage(window.location.href.split("page=")[1] - 1);
    getYoutubePageCount().then((response) => {
      setYoutubeCount(response.data);
    });
  }, []);

  const postVideo = () => {
    postYoutubeVideo(value, videoUrl).then((response) => {
      getYoutubePageCount().then((response) => {
        setYoutubeCount(response.data);
        alert("동영상이 추가되었습니다!");
        setIsModalOpen(false);
        clearState();
        setSelectedPage(response.data - 1);
        window.location.href = `/admin/video?page=${response.data}`;
      });
    });
  };

  const clearState = () => {
    setValue("");
    setVideoUrl("");
    setIsModalOpen(false);
  };

  const confirmForm = () => {
    if (value === "" && videoUrl === "") {
      alert("제목과 동영상 주소를 입력해주세요!");
    } else if (value === "" || isSpaceWord(value)) {
      alert("제목을 입력해주세요! 공백은 인정되지 않습니다.");
    } else if (videoUrl === "" || isSpaceWord(videoUrl)) {
      alert("동영상 주소를 입력해주세요! 공백은 인정되지 않습니다.");
    } else {
      postVideo();
    }
  };

  const isSpaceWord = (word) => {
    // 공백으로만 이루어진 경우 체크
    const removedWord = word.replace(/\s/g, "");
    if (removedWord === "") {
      return true;
    }
    return false;
  };

  useEffect(() => {
    let lastUrl = videoUrl.split("/");
    let urlLocation = lastUrl[lastUrl.length - 1];
    let handledLocation = urlLocation.split("=");
    setImageInformation(handledLocation[handledLocation.length - 1]);
  }, [videoUrl]);

  return (
    <div className="h-screen w-screen">
      <AdminMenuBar selected_page={8} />
      <div className="w-full bg-white">
        <div className="youtube_banner">
          <a
            href="https://www.youtube.com/channel/UCSUW_pGH6ru65irfT4I7sog"
            target="_blank"
            rel="noreferrer"
          >
            <div className="youtube_image">
              <img src={youtubeLink} className="youtube_link" />
            </div>
          </a>
        </div>
        <Flex maxW="100%" marginY="10px" justifyContent="right">
          <Text mt="25px" mr="20px" as="b" fontSize="3xl">
            동영상 편집 및 삭제를 원하시면 해당 동영상을 클릭하십시오.
          </Text>
          <Button
            mt="20px"
            mb="-30px"
            mr="120px"
            cursor="pointer"
            colorScheme="blue"
            fontSize="3xl"
            px="10px"
            py="20px"
            onClick={() => setIsModalOpen(true)}
          >
            동영상 추가
          </Button>
        </Flex>
        <AdminVideoList
          pageCount={youtubeCount}
          changePage={changePage}
          selectedPage={selectedPage}
          setSelectedPage={setSelectedPage}
          setYoutubeCount={setYoutubeCount}
        />
      </div>

      <Modal
        isOpen={isModalOpen}
        style={{
          content: {
            width: "400px",
            height: "600px",
            margin: "auto",
            marginTop: "80px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          },
        }}
      >
        <Flex alignItems="center" direction="column">
          <Text fontSize="5xl" as="b" mb="30px" mt="10px">
            동영상 추가
          </Text>

          <Flex alignContent="center" mb="10px" mt="10px">
            <Text fontSize="2xl" mt="-1px" width="45px">
              제목:
            </Text>
            <Input
              htmlSize={30}
              value={value}
              onChange={handleChange}
              fontSize="xl"
              size="md"
            />
          </Flex>

          <Flex alignContent="center" mb="10px" mt="10px">
            <Text fontSize="2xl" mt="-1px" width="45px">
              주소:
            </Text>
            <Input
              htmlSize={30}
              defaultValue={videoUrl}
              onChange={handleVideoChange}
              fontSize="xl"
              size="md"
            />
          </Flex>

          <Image
            mt="10px"
            mb="10px"
            height="250px"
            src={`https://img.youtube.com/vi/${imageInformation}/0.jpg`}
            alt="미리보기"
          />

          <Text textAlign="center" as="b" fontSize="xl">
            유튜브 동영상 페이지에서{" "}
            <span style={{ color: "red" }}>공유 버튼</span>을 누른 후
          </Text>
          <Text textAlign="center" as="b" fontSize="xl">
            <span style={{ color: "red" }}>나오는 주소를 복사</span>하여 올리는
            것을 권장합니다.
          </Text>

          <Flex mt="30px" mb="10px">
            <Button
              fontSize="xl"
              size="md"
              colorScheme="red"
              mr={3}
              onClick={() => clearState()}
            >
              닫기
            </Button>
            <Button
              fontSize="xl"
              size="md"
              variant="ghost"
              onClick={confirmForm}
            >
              추가
            </Button>
          </Flex>
        </Flex>
      </Modal>

      <Address />
    </div>
  );
};
